import { render, staticRenderFns } from "./BlogPostCard.vue?vue&type=template&id=19556fe2&scoped=true&"
import script from "./BlogPostCard.vue?vue&type=script&lang=js&"
export * from "./BlogPostCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostCard.vue?vue&type=style&index=0&id=19556fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19556fe2",
  null
  
)

export default component.exports